enum ELanguages {
  ENGLISH = 'en',
}

export default ELanguages;
